import React, { useState } from "react";

const OnlineClassBandwidthCalculator = () => {
  const [salary, setSalary] = useState("");
  const [tax, setTax] = useState("");
  const [netSalary, setNetSalary] = useState(null);

  const calculateSalary = () => {
    const taxAmount = (salary * tax) / 100;
    setNetSalary(salary - taxAmount);
  };

  return (
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg mx-auto mt-5">
      <h2 className="text-xl font-bold text-center text-blue-600">Online Class Bandwidth Calculator</h2>
      <input type="number" placeholder="Gross Salary ($)" className="border p-2 w-full mt-3" onChange={(e) => setSalary(e.target.value)} />
      <input type="number" placeholder="Tax Percentage (%)" className="border p-2 w-full mt-3" onChange={(e) => setTax(e.target.value)} />
      <button className="mt-4 bg-blue-500 text-white py-2 px-4 rounded w-full" onClick={calculateSalary}>Calculate Net Salary</button>
      {netSalary && <div className="mt-3 text-center text-lg">Net Salary: <span className="font-bold text-green-600">${netSalary}</span></div>}
    </div>
  );
};

export default OnlineClassBandwidthCalculator;
